import React, { useEffect, useState, useRef, useCallback } from 'react'
import Puff from 'react-loading-icons/dist/esm/components/puff';
import { Link, useParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { FaDashcube, FaPrint, FaTrash } from 'react-icons/fa';
import '../Customcss/saleEntry.css';
import { Box } from '@mui/system';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

function EditSaleInvoice() {
  const [paymentType, setPaymentType] = useState(0);
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [results, setresutls] = useState([]);
  const [extra_discount, setextra_discount] = useState(0);
  const [fix_discount, setfix_discount] = useState(0);
  const [sectors, setSectors] = useState([]);
  const [subsectors, setSubSectors] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [salesmanId, setSalesmanId] = useState([]);
  const [manualdate, setManualdate] = useState('');
  const [isClick, setIsClick] = useState(false);
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [pBalance, setPbalance] = useState(0);
  const [entercash, setEntercash] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [recievediscount, setRecieveDiscount] = useState(0);
  const [ppadvance, setPPadvance] = useState(0);
  const [recovery, setRecovery] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [balance, setBalance] = useState(0);
  const [salesTax, setSalesTax] = useState(0);
  const [shipping, setShipping] = useState(0);
  const [salesTaxAmount, setSalesTaxAmount] = useState(0);
  const [totalCtn, setTotalCtn] = useState(0);
  const [totalPcs, setTotalPcs] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [totalUnitSalePrice, setTotalUnitSalePrice] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [isCheck, setIsCheck] = useState(localStorage.getItem('radio') ? localStorage.getItem('radio') : '1');

  const handleRadioChange = (event) => {
    setIsCheck(event.target.value);
    localStorage.setItem('radio', event.target.value);
    toast('Your Mode Is Switching!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const handleDiscountPercent = (id, event) => {
    setRecieveDiscount(0);
    const newItems = [...items];
    const index = newItems.findIndex(item => item.id === id);
    newItems[index].dis_percent = event.target.value;
    const subtotaldis = (newItems[index].qty * newItems[index].unitsaleprice) * event.target.value / 100;
    newItems[index].discounted_amount = parseFloat(subtotaldis).toFixed(2);
    newItems[index].grandtotal = parseFloat((newItems[index].qty * newItems[index].unitsaleprice) - (subtotaldis)).toFixed(2);
    setItems(newItems);
  }

  const handleSubTotalDiscount = (id, event) => {
    const newItems = [...items];
    const index = newItems.findIndex(item => item.id === id);
    newItems[index].discounted_amount = event.target.value;
    const discountvalue = event.target.value;
    const total = parseFloat(newItems[index].qty * newItems[index].unitsaleprice).toFixed(2);
    const disval = total - discountvalue;
    const disper = (((total - disval) / total) * 100).toFixed(2);
    newItems[index].dis_percent = disper;
    newItems[index].grandtotal = parseFloat((newItems[index].qty * newItems[index].unitsaleprice) - (discountvalue)).toFixed(2);
    setItems(newItems);
  }

  const handleShipping = (e) => {
    if (e.target.value === '') {
      setShipping(0);
    } else {
      setShipping(e.target.value);
    }
  }

  const handleFilterCart = (e) => {
    const { value } = e.target;
    const items = document.querySelectorAll(".itembody");
    items.forEach((item) => {
      const nameField = item.querySelector("[name='name']");
      const itemName = nameField.value.toLowerCase();
      const shouldShowItem = itemName.indexOf(value.toLowerCase()) > -1;
      if (shouldShowItem) {
        item.style.display = "grid";
      } else {
        item.style.display = "none";
      }
    });
  }

  const handleEntercash = (e) => {
    e.preventDefault();
    if (e.target.value === '') {
      setEntercash(0);
    } else {
      setEntercash(e.target.value);
    }
  }

  const handleDiscount = (e) => {
    e.preventDefault();
    if (e.target.value === '') {
      setDiscount(0);
      setfix_discount(0);
    } else {
      if (e.target.value > (parseFloat(grandTotal) + parseFloat(shipping) + parseFloat(salesTaxAmount))) {
        toast.error('Discount is greater than total', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setDiscount(0);
        setfix_discount(0);
      } else {
        setDiscount(e.target.value);
        setRecieveDiscount(e.target.value);
        setfix_discount(e.target.value - extra_discount);
      }
    }
  }

  const handleSalesTax = (e) => {
    e.preventDefault();
    setSalesTax(e.target.value);
  }

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [items.length]);

  useEffect(() => {
    axios.get(`/api/getproductsforinvoiceinvoice`).then(res => {
      setresutls(res.data.products);
    });
  }, [id])

  useEffect(() => {
    setIsClick(true);
    axios.get('/sanctum/csrf-cookie').then(response => {
      axios.get(`/api/editinvoice/${id}`).then(res => {
        setSalesmanId(res.data.salesman);
        setSectors(res.data.sector);
        setSubSectors(res.data.subsector);
        setCustomer(res.data.customer);
        setManualdate(res.data.ledgers.manual_date);
        if (res.data.ledgers.payment_type === 'Cash') {
          setPaymentType(0);
        } else {
          setPaymentType(1);
        }
        setItems(res.data.items);
        setEntercash((parseFloat(res.data.ledgers.total_cash) + parseFloat(res.data.ledgers.recieve)));
        setPbalance(res.data.prebalance);
        setDiscount(res.data.ledgers.discounted_amount);
        setfix_discount(res.data.ledgers.discounted_amount - res.data.ledgers.extra_discount);
        setRecieveDiscount(res.data.ledgers.discounted_amount);
        setSalesTax(res.data.ledgers.sales_tex_percent);
        setSalesTaxAmount(res.data.ledgers.sales_tex !== null ? res.data.ledgers.sales_tex : 0);
        setShipping(res.data.ledgers.shipping !== null ? res.data.ledgers.shipping : 0);
        setIsClick(false);
      });
    });
  }, [id]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (autocompleteRef.current) {
        autocompleteRef.current.focus();
      }
    }
  };

  const handleRemove = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const handlePackChange = useCallback((id, event) => {
    setItems(prevItems => {
      const index = prevItems.findIndex(item => item.id === id);
      const newQty = Math.floor(event.target.value === '' ? +(prevItems[index].pcs) : (parseFloat(event.target.value) * parseFloat(prevItems[index].pack_size)) + parseFloat(prevItems[index].pcs));
      const fixqty = prevItems[index].qty;
      if (newQty < 0 || newQty > prevItems[index].remaining + fixqty) {
        alert('Item quantity should not be less than 0 or greater than stock.');
        return prevItems;
      }

      const qtyDifference = newQty - prevItems[index].qty;
      const updatedResults = results.map((result) =>
        result.id === id
          ? { ...result, remaining: result.remaining - qtyDifference }
          : result
      );

      const newItem = {
        ...prevItems[index],
        qty: newQty,
        pack_qty: event.target.value,
        remaining: prevItems[index].remaining - qtyDifference,
        discounted_amount: parseFloat((newQty * prevItems[index].unitsaleprice) * prevItems[index].dis_percent / 100).toFixed(2),
        grandtotal: parseFloat(
          newQty * prevItems[index].unitsaleprice -
          (newQty * prevItems[index].unitsaleprice * prevItems[index].dis_percent) / 100
        ).toFixed(2),
      };

      setresutls(updatedResults);
      return [...prevItems.slice(0, index), newItem, ...prevItems.slice(index + 1)];
    });
  }, [setItems, setresutls, results]);

  const handlePiecesChange = useCallback((id, event) => {
    setItems(prevItems => {
      const index = prevItems.findIndex(item => item.id === id);
      const newQty = (event.target.value === '' ? 0 + (Math.floor(prevItems[index].pack_qty * prevItems[index].pack_size)) : parseFloat(event.target.value) + (Math.floor(prevItems[index].pack_qty * prevItems[index].pack_size)));
      const pack_qty = Math.floor(newQty / prevItems[index].pack_size);
      const pcs = newQty % prevItems[index].pack_size;

      if (newQty < 1 || newQty > prevItems[index].remaining + prevItems[index].qty) {
        alert('Item quantity should not be less than 0 or greater than stock.');
        return prevItems;
      }

      const qtyDifference = newQty - prevItems[index].qty;
      const updatedResults = results.map((result) =>
        result.id === id
          ? { ...result, remaining: result.remaining - qtyDifference }
          : result
      );

      const newItem = {
        ...prevItems[index],
        qty: newQty,
        pack_qty: pack_qty,
        pcs: pcs,
        remaining: prevItems[index].remaining - qtyDifference,
        discounted_amount: parseFloat((newQty * prevItems[index].unitsaleprice) * prevItems[index].dis_percent / 100).toFixed(2),
        grandtotal: parseFloat(
          newQty * prevItems[index].unitsaleprice -
          (newQty * prevItems[index].unitsaleprice * prevItems[index].dis_percent) / 100
        ).toFixed(2),
      };

      setresutls(updatedResults);
      return [...prevItems.slice(0, index), newItem, ...prevItems.slice(index + 1)];
    });
  }, [setItems, setresutls, results]);

  const handleQtyChange = useCallback((id, event) => {
    setItems((prevItems) => {
      const index = prevItems.findIndex((item) => item.id === id);
      const newQty = parseFloat(event.target.value === '' ? 0 : event.target.value);
      const pack_qty = Math.floor(newQty / prevItems[index].pack_size);
      const pcs = newQty % prevItems[index].pack_size;
      const fixqty = prevItems[index].qty;

      if (newQty < 1 || newQty > prevItems[index].remaining + fixqty) {
        alert('Item quantity should not be less than 0 or greater than stock.');
        return prevItems;
      }

      const qtyDifference = newQty - prevItems[index].qty;
      const updatedResults = results.map((result) =>
        result.id === id
          ? { ...result, remaining: result.remaining - qtyDifference }
          : result
      );

      const newItem = {
        ...prevItems[index],
        qty: newQty,
        pack_qty: pack_qty,
        pcs: pcs,
        remaining: prevItems[index].remaining - qtyDifference,
        discounted_amount: parseFloat((newQty * prevItems[index].unitsaleprice) * (prevItems[index].dis_percent) / 100).toFixed(2),
        grandtotal: parseFloat(
          newQty * prevItems[index].unitsaleprice -
          (newQty * prevItems[index].unitsaleprice * prevItems[index].discountpercent) / 100
        ).toFixed(2),
      };

      setresutls(updatedResults);
      return [...prevItems.slice(0, index), newItem, ...prevItems.slice(index + 1)];
    });
  }, [setItems, results, setresutls]);

  const handleUnitSalePriceChange = (id, event) => {
    const newItems = [...items];
    const index = newItems.findIndex(item => item.id === id);
    newItems[index].unitsaleprice = event.target.value;
    const subtotaldis = (newItems[index].qty * newItems[index].unitsaleprice) * newItems[index].dis_percent / 100;
    newItems[index].discounted_amount = parseFloat(subtotaldis).toFixed(2);
    newItems[index].grandtotal = parseFloat((newItems[index].qty * newItems[index].unitsaleprice) - (subtotaldis)).toFixed(2);
    setItems(newItems);
  };

  useEffect(() => {
    const qty = items.reduce((acc, item) => {
      const value = parseInt(item.qty);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    setTotalQty(qty);
    const pcs = items.reduce((acc, item) => {
      const value = parseInt(item.pcs);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    setTotalPcs(pcs);

    const ctn = items.reduce((acc, item) => {
      const value = parseInt(item.pack_qty);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    setTotalCtn(Math.floor(ctn));

    const weight = items.reduce((acc, item) => {
      const value = parseFloat(item.weight * item.qty);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    setTotalWeight(weight.toFixed(2));
    const unitSalePrice = items.reduce((acc, item) => {
      const value = parseFloat(item.unitsaleprice);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    setTotalUnitSalePrice(unitSalePrice.toFixed(2));

    const sumgrandtotal = items.reduce((acc, item) => {
      const value = parseFloat(item.unitsaleprice * item.qty);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    setGrandTotal(sumgrandtotal.toFixed(2));

    const totaldiscount = items.reduce((acc, item) => {
      const value = parseFloat(item.discounted_amount);
      return isNaN(value) ? acc : acc + value;
    }, 0);

    setextra_discount(totaldiscount);
    setfix_discount(discount - totaldiscount);

    if (recievediscount > 0) {
      setDiscount(parseFloat(totaldiscount).toFixed(2));
    } else {
      if (totaldiscount > discount) {
        setDiscount(totaldiscount.toFixed(2));
        setRecieveDiscount(0);
      } else if (totaldiscount < discount) {
        setDiscount(totaldiscount.toFixed(2));
        setRecieveDiscount(0);
      }
    }
  }, [items, discount, recievediscount]);

  async function handleSubmit(val) {
    try {
      const { data: { item: newItem } } = await axios.get(`/api/fetchitem/${val.id}`);
      const itemExists = items.find(({ id }) => id === newItem.id);

      if (itemExists) {
        toast.error('Item Already Added!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        const remqty = {
          'remaining': newItem.qty,
          'pro_id': newItem.id,
          'dis_percent': newItem.extra_discount ? newItem.extra_discount : 0,
          'discounted_amount': newItem.extra_discount ? newItem.extra_discount : 0,
        }
        setItems([
          ...items,
          { ...newItem, qty: 1, pcs: 0, pack_qty: 0, unitsaleprice: (localStorage.getItem('radio') === '1' ? newItem.unitsaleprice : newItem.unitretailprice), ...remqty }
        ]);
        setSelectedOption(null);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (parseFloat(entercash) > (parseFloat(grandTotal) - parseFloat(discount) + parseFloat(shipping) + parseFloat(salesTaxAmount))) {
      const afterdiscount = parseFloat(pBalance) + parseFloat(grandTotal) - parseFloat(entercash) - parseFloat(discount);
      setRemaining(0);
      setPPadvance((parseFloat(grandTotal) - parseFloat(discount) + parseFloat(shipping) + parseFloat(salesTaxAmount)).toFixed(2));
      setRecovery((parseFloat(entercash) - (parseFloat(grandTotal) - parseFloat(discount) + parseFloat(shipping) + parseFloat(salesTaxAmount))).toFixed(2));
      setBalance(afterdiscount.toFixed(2));
    } else {
      const afterdiscount = parseFloat(pBalance) + parseFloat(grandTotal) - parseFloat(entercash) - parseFloat(discount);
      setRemaining(parseFloat(parseFloat(afterdiscount) + parseFloat(shipping) + parseFloat(salesTaxAmount)).toFixed(2));
      setPPadvance(parseFloat(entercash));
      setRecovery(0);
      setBalance(afterdiscount.toFixed(2));
    }
    setSalesTaxAmount((parseFloat(grandTotal) + parseFloat(shipping)) * salesTax / 100);
  }, [entercash, pBalance, discount, items, grandTotal, shipping, salesTax, salesTaxAmount]);

  const handleUpdateReciept = (e) => {
    setIsClick(true);
    const data = {
      letter: items,
      sector: sectors.id,
      subsector: subsectors.id,
      ppcell: customer.id,
      manualdate: manualdate,
      recovery: recovery,
      ppadvance: ppadvance,
      salesmanid: salesmanId.id,
      sales_tex_percent: salesTax,
      shipping: shipping,
      salestaxamount: salesTaxAmount,
      supergrandtotal: grandTotal,
      discount: discount,
      extra_discount: extra_discount,
      visitor_id: id,
      paymentType: paymentType
    }

    if (data.letter.length > 0 && data.ppcell > 0 && data.manualdate !== '') {
      axios.put('/api/updateinvoice', data).then(res => {
        if (res.data.msg === '0') {
          toast.error('Day Has Been Closed!', {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsClick(false);
          return false;
        } else {
          toast.success('Updated Successfully!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsClick(false);
        }
      });
    } else {
      Swal.fire({
        position: 'top-end',
        icon: 'info',
        title: 'Fill All Fields',
        showConfirmButton: false,
        timer: 1500
      })
      setIsClick(false);
    }
  }

  const handlePaymentType = () => {
    if (paymentType === 0) {
      setPaymentType(1);
    } else {
      setPaymentType(0);
    }
  }

  return (
    <div className='sale-entry-main'>
      <div className='sale-entry-container'>
        <div className='sidebar-section'>
          <div className='info-card'>
            <div className='card-header'>
              <div className='header-icon'>✏️</div>
              <h3>Edit Invoice Information</h3>
            </div>

            <div className='form-field'>
              <label>Salesman</label>
              <select className='modern-select' value={salesmanId.id}>
                <option>Select Salesman</option>
                <option value={salesmanId.id}>{salesmanId.name}</option>
              </select>
            </div>

            <div className='form-field'>
              <label>📍 Region</label>
              <select className='modern-select' value={sectors.id}>
                <option>Select Region</option>
                <option value={sectors.id}>{sectors.name}</option>
              </select>
            </div>

            <div className='form-field'>
              <label>🏙️ City</label>
              <select className='modern-select' value={subsectors.id}>
                <option>Select City</option>
                <option value={subsectors.id}>{subsectors.name}</option>
              </select>
            </div>

            <div className='form-field'>
              <label>🏪 Customer</label>
              <select className='modern-select' value={customer.id}>
                <option value={customer.id}>{customer.name}</option>
              </select>
            </div>

            <div className='form-field'>
              <label>📅 Invoice Date</label>
              <input type="date" readOnly className='modern-input' name='manualdate' value={manualdate} onChange={(e) => setManualdate(e.target.value)} />
            </div>

            <div className='radio-group-custom price-group'>
              <label className='radio-btn'>
                <input type="radio" name="radio-group" value="2" checked={isCheck === "2"} onChange={handleRadioChange} />
                <span>Sale</span>
              </label>
              <label className='radio-btn'>
                <input type="radio" name="radio-group" value="1" checked={isCheck === "1"} onChange={handleRadioChange} />
                <span>S.WholeSale</span>
              </label>
              <label className='radio-btn'>
                <input type="radio" name="radio-group" value="3" checked={isCheck === "3"} onChange={handleRadioChange} />
                <span>Dragon</span>
              </label>
            </div>
          </div>
        </div>

        <div className='main-section'>
          <div className='search-area'>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              value={selectedOption}
              onChange={(event, newValue) => {
                setSelectedOption(newValue);
                handleSubmit(newValue);
              }}
              getOptionLabel={(results) => `${results.name} (${results.alias})`}
              isOptionEqualToValue={(option, value) =>
                option.name === value.name || option.alias === value.alias
              }
              options={results}
              noOptionsText={"No Item Found"}
              renderOption={(props, results) => (
                <Box component="li" {...props} key={results.id}>
                  {results.name}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={selectedOption ? <Puff stroke="#667eea" height={24} width={24} /> : '🔍 Search Item'}
                  variant="outlined"
                  className='search-box'
                  inputRef={autocompleteRef}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' && params.inputProps.value) {
                      const inputText = params.inputProps.value.toLowerCase();
                      const matchingOptions = results.filter((option) =>
                        (option.name || '').toLowerCase().indexOf(inputText) !== -1 ||
                        (option.alias || '').toLowerCase().indexOf(inputText) !== -1
                      );
                      if (matchingOptions.length > 0) {
                        setSelectedOption(matchingOptions[0]);
                        handleSubmit(matchingOptions[0]);
                      }
                    }
                  }}
                />
              )}
            />
          </div>

          <div className='cart-table-wrapper'>
            <div className='cart-header-grid'>
              <div className='col-search'>
                <input className='search-filter-input' placeholder='🔍 Search item...' onKeyUp={(e) => handleFilterCart(e)} />
              </div>
             
              <div className='col-ctn'>Ctn</div>
              <div className='col-pcs'>Pcs</div>
              <div className='col-qty'>Qty</div>
              <div className='col-weight'style={{display:'none'}}>Weight</div>
              <div className='col-rem'>Rem</div>
              <div className='col-rate'>Rate</div>
              <div className='col-discount'>Percent</div>
              <div className='col-dis-amount'>Discount</div>
              <div className='col-total'>Total</div>
              <div className='col-action'>Action</div>
            </div>

            <div className='cart-body-scroll'>
              {items.length > 0 ? '' : <div className='loading-placeholder'><Puff stroke='#667eea' /></div>}
              {items && items.map((item, index) => (
                <div className='cart-row-grid itembody' key={item.id}>
                  <div className='col-name'>
                    <TextField
                      size="small"
                      name='name'
                      value={item.name}
                      onKeyDown={handleKeyDown}
                      className='field-name'
                    />
                  </div>
                  <div className='col-ctn'>
                    <TextField
                      size="small"
                      label={"size(" + item.pack_size + ")"}
                      name='pack_qty'
                      type='number'
                      value={item.pack_qty ? Math.floor(item.pack_qty) : ''}
                      onChange={event => handlePackChange(item.id, event)}
                      onKeyDown={handleKeyDown}
                      className='field-small'
                    />
                  </div>
                  <div className='col-pcs'>
                    <TextField
                      size="small"
                      label="pcs"
                      name='pcs'
                      type='number'
                      value={item.pcs ? item.pcs : ''}
                      onChange={event => handlePiecesChange(item.id, event)}
                      onKeyDown={handleKeyDown}
                      className='field-small'
                    />
                  </div>
                  <div className='col-qty'>
                    <TextField
                      size="small"
                      label="Qty"
                      inputRef={index === items.length - 1 ? inputRef : null}
                      name='qty'
                      type='number'
                      value={item.qty}
                      onChange={(e) => handleQtyChange(item.id, e)}
                      onKeyDown={handleKeyDown}
                      className='field-qty'
                    />
                  </div>
                  <div className='col-weight'style={{display:'none'}}>
                    <TextField
                      size="small"
                      label="weight"
                      name='weight'
                      type='number'
                      disabled
                      value={(item.weight * item.qty).toFixed(2)}
                      className='field-small'
                    />
                  </div>
                  <div className='col-rem'>
                    <TextField
                      size="small"
                      label="remaining"
                      name='remaining'
                      type='number'
                      disabled
                      value={parseFloat(item.remaining).toFixed(2)}
                      className='field-small'
                    />
                  </div>
                  <div className='col-rate'>
                    <TextField
                      size="small"
                      label="Rate"
                      name='unitsaleprice'
                      type='number'
                      value={item.unitsaleprice}
                      onChange={event => handleUnitSalePriceChange(item.id, event)}
                      onKeyDown={handleKeyDown}
                      className='field-rate'
                    />
                  </div>
                  <div className='col-discount'>
                    <TextField
                      size="small"
                      label="Percent"
                      name='discount'
                      type='number'
                      value={item.dis_percent}
                      onChange={event => handleDiscountPercent(item.id, event)}
                      onKeyDown={handleKeyDown}
                      className='field-discount'
                    />
                  </div>
                  <div className='col-dis-amount'>
                    <TextField
                      size="small"
                      label="Discount"
                      name='subtotaldiscount'
                      type='number'
                      value={item.discounted_amount}
                      onChange={event => handleSubTotalDiscount(item.id, event)}
                      onKeyDown={handleKeyDown}
                      className='field-dis-amount'
                    />
                  </div>
                  <div className='col-total'>
                    <TextField
                      size="small"
                      label="total"
                      name='total'
                      type='number'
                      disabled
                      value={parseFloat(item.unitsaleprice * item.qty).toFixed(2)}
                      className='field-total'
                    />
                  </div>
                  <div className='col-action'>
                    <FaTrash onClick={() => handleRemove(item.id)} className='delete-icon' />
                  </div>
                </div>
              ))}
            </div>

            <div className='cart-footer-total'>
              <div className='footer-item'>Total: <span>{totalCtn}</span></div>
              <div className='footer-item'>Pcs: <span>{totalPcs}</span></div>
              <div className='footer-item'>Qty: <span>{totalQty}</span></div>
              <div className='footer-item'>Weight: <span>{totalWeight}</span></div>
              <div className='footer-item'>Rate: <span>{totalUnitSalePrice}</span></div>
              <div className='footer-item discount'>Discount: <span>{extra_discount.toFixed(2)}</span></div>
              <div className='footer-item grand'>Grand: <span>{grandTotal}</span></div>
            </div>

            <div className='calc-row'>
              <div className='calc-item'>
                <label>💰 Discount:</label>
                <input type='number' className='input-discount' value={discount !== 0 ? discount : ''} onChange={(e) => handleDiscount(e)} />
              </div>
              <div className='calc-item'>
                <label>Fix Dis:</label>
                <input className='input-fix' value={extra_discount ? extra_discount.toFixed(2) : ''} disabled />
              </div>
              <div className='calc-item'>
                <label>Ext Dis:</label>
                <input className='input-ext' value={fix_discount ? fix_discount.toFixed(2) : ''} disabled />
              </div>
              <div className='calc-item'>
                <label>📊 GST/HST:</label>
                <input className='input-tax' value={salesTax} onChange={handleSalesTax} />
              </div>
            </div>

            <div className='calc-row'>
              <div className='calc-item'>
                <label>💵 Paid:</label>
                <input className='input-paid' name='ppadvance' disabled value={ppadvance} />
              </div>
              <div className='calc-item payment-type'>
                <label>{paymentType === 0 ? 'Cash' : 'Card'}:</label>
                <input type='checkbox' checked={paymentType === 0} value={paymentType} onChange={handlePaymentType} className='payment-checkbox' />
              </div>
              <div className='calc-item'>
                <label>💰 Enter Cash:</label>
                <input type='number' className='input-cash' name='entercash' value={entercash} onChange={handleEntercash} />
              </div>
              <div className='calc-item'>
                <label>🔄 Recovery:</label>
                <input className='input-recovery' name='recovery' disabled value={recovery} />
              </div>
              <div className='calc-item'>
                <label>🚚 Shipping:</label>
                <input className='input-shipping' value={shipping !== 0 ? shipping : ''} onChange={(e) => handleShipping(e)} />
              </div>
            </div>

            <div className='summary-row'>
              <div className='summary-item'>Pre Balance: <span>{parseFloat(pBalance).toFixed(2)}</span></div>
              <div className='summary-item'>After Dis: <span>{remaining}</span></div>
              <div className='summary-item'>GST: <span>{salesTaxAmount}</span></div>
              <div className='summary-item'>Shipping: <span>{shipping}</span></div>
              <div className='summary-item balance'>Balance: <span className='balance-amount'>{parseFloat(parseFloat(balance) + parseFloat(salesTaxAmount) + parseFloat(shipping)).toFixed(2)}</span></div>
            </div>

            <div className='action-buttons-row'>
              <button className='btn-save' disabled={isClick} onClick={(e) => handleUpdateReciept(e)}>
                <FaPrint /> {isClick ? <Puff stroke="#fff" height={20} width={20} speed={.75} /> : 'Update & Save'}
              </button>
              <button className='btn-reset'>
                <FaPrint /> Reset Values
              </button>
              <Link to="/">
                <button className='btn-dashboard'>
                  <FaDashcube /> Dashboard/Home
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditSaleInvoice;